import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { systemMessages } from '../mockData/system-messages-data';

const SystemMessageApi = [rest.get(`${API_ROOT}system-messages`, (req, res, ctx) => res(ctx.json(systemMessages)))];

export default SystemMessageApi;
